// Announcement messages - you can add or change these as needed
export const announcements = [
  "✨ Check our Instagram, use the story template, and tag us to capture the moment!",
  "✨ インスタグラムをチェックして、ストーリーテンプレートを使ってタグ付けして、その瞬間を捉えよう！",
  "✨ 查看我们的Instagram，使用故事模板并标记我们以捕捉这一刻！",
  "📍 See you in Bogor, Indonesia — November 17–19, 2025",
  "📍 インドネシアのボゴールでお会いしましょう — 2025年11月17〜19日",
  "📍 2025年11月17日至19日，印尼茂物见！",
  "💡 Turn your research into real-world impact at APFITA 2025!",
  "💡 あなたの研究をAPFITA 2025で現実のインパクトに変えましょう！",
  "💡 在APFITA 2025将你的研究转化为现实影响！",
  "🎉 Celebrating 15 years of agri-tech breakthroughs and collaboration!",
  "🎉 農業テクノロジーの15年の革新と協力を祝おう！",
  "🎉 庆祝农业科技15年的突破与合作！",
  "🌾 Discover the latest in AI, IoT, and digital agriculture innovation.",
  "🌾 AI、IoT、デジタル農業の最新イノベーションを発見！",
  "🌾 探索人工智能、物联网和数字农业的最新创新。",
  "🌊 Dive into Indonesia’s vibrant agro-maritime ecosystem — only at APFITA!",
  "🌊 インドネシアの活気あるアグロマリタイム・エコシステムを体験 — APFITAだけ！",
  "🌊 体验印尼充满活力的农业海洋生态系统 — 尽在APFITA！",
  "🤝 Connect with global experts, innovators, and change-makers 🌍",
  "🤝 世界中の専門家、イノベーター、チェンジメーカーとつながろう 🌍",
  "🤝 与全球专家、创新者和变革者相连 🌍",
  "🔥 Experience inspiring talks, networking, and cutting-edge technology demos!",
  "🔥 刺激的な講演、ネットワーキング、最先端の技術デモを体験！",
  "🔥 体验鼓舞人心的演讲、交流和前沿科技展示！",
  "🌿 Welcome to APFITA 2025 — where ideas grow and innovation thrives!",
  "🌿 APFITA 2025へようこそ — アイデアが芽生え、イノベーションが花開く場所！",
  "🌿 欢迎来到APFITA 2025 — 思想成长、创新繁荣的地方！",
  "📢 Early bird registration opens soon — secure your seat now!",
  "📢 早期登録はまもなく開始 — 今すぐ席を確保しよう！",
  "📢 早鸟注册即将开启 — 立即预定席位！",
  "🌱 Let’s shape the future of smart, sustainable agriculture together!",
  "🌱 スマートで持続可能な農業の未来を一緒に創りましょう！",
  "🌱 让我们共同塑造智能与可持续农业的未来！",
];
